import { appThemes } from "../env";
import { appStyles, baseAppStyle } from "../config/appTheme";
export const PROJECT_INKASSIER = "inkassier";
export const PROJECT_INVONED = "invoned";
export const getAppThemeName = () => appThemes[process.env.MIX_APP_PROJECT] || PROJECT_INVONED;
export const isProject = (project) => project === getAppThemeName();
export const getAppTheme = () => {
    const theme = getAppThemeName();
    return Object.assign(Object.assign({}, baseAppStyle), (appStyles[theme] || {}));
};
export const getLogoForTheme = () => getAppTheme().logo;
